import React, { useState } from 'react';
import { ContactsInfo } from '../api/model/Contacts';

type ContactCardProps = {
  contact: Partial<ContactsInfo> & {
    name?: string;
    email?: string;
    phone?: string;
    subcategory?: string;
    title?: string;
    extension?: string;
    directions?: string;
  };
  location?: boolean;
};

const ContactCard: React.FC<ContactCardProps> = ({ contact, location }) => {
  const [showDirections, setShowDirections] = useState(false);
  const phone = contact.phone || '';
  const displayName = contact.name || contact.subcategory || 'Contact';

  return (
    <div className="contact-card">
      {phone ? (
        <a className="contact-card__link" href={`tel:${phone}`}>
          <div className="contact-card__body">
            <div className="contact-card__name">
              {displayName}
              {contact.title ? ` – ${contact.title}` : ''}
            </div>
            {contact.subcategory ? (
              <div className="contact-card__badge">{contact.subcategory}</div>
            ) : null}
            {contact.email ? <div className="contact-card__meta">{contact.email}</div> : null}
            <div className="contact-card__phone">
              {phone}
              {contact.extension ? ` Ext: ${contact.extension}` : ''}
            </div>
          </div>
        </a>
      ) : (
        <div className="contact-card__body">
          <div className="contact-card__name">
            {displayName}
            {contact.title ? ` – ${contact.title}` : ''}
          </div>
          {contact.subcategory ? (
            <div className="contact-card__badge">{contact.subcategory}</div>
          ) : null}
          {contact.email ? <div className="contact-card__meta">{contact.email}</div> : null}
        </div>
      )}
      {location && contact.directions ? (
        <>
          <button
            type="button"
            className="contact-card__directions-toggle"
            onClick={() => setShowDirections(!showDirections)}
          >
            Directions
          </button>
          {showDirections ? (
            <div className="contact-card__directions">{contact.directions}</div>
          ) : null}
        </>
      ) : null}
    </div>
  );
};

export default ContactCard;
